import { DesktopBackend, tauriBridge } from "./desktopBackend";
import type { Backend } from "./taskApi";
import { WebBackend, connectWithWasm } from "./webBackend";

function insideTauriShell(): boolean {
  return "__TAURI_INTERNALS__" in window;
}

export async function selectBackend(): Promise<Backend> {
  if (insideTauriShell()) return new DesktopBackend(await tauriBridge());
  return new WebBackend(connectWithWasm);
}
